
import tidalButton from '@tidal/styles-button';

export default {
    components: {
        tidalButton,
    },
    props: {
        isClient: {
            type: Boolean,
            default: false,
        },
        themeWhite: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        buttonStyle: function() {
            if (this.isClient) {
                return 'btn-dark';
            }

            if (this.themeWhite) {
                return 'btn-secondary-outline';
            }

            return 'btn-secondary-outline';
        },
    },
};
